export const FEATURE_FLAGS = {
  // Example: SWITCH_USER_ROLE: "switch-user-role",
  HIDE_CONTRACT_BOX: "hide-contract-box",
  WORKER_RETENTION_BONUS: "worker-retention-bonus",
  FOCUS_GET_MATCHED_WITH_RECRUITER_CTA: "focus-get-matched-with-recruiter-cta",
  LINK_ORGANIZATION_PROFILE: "link-organization-profile",
};
